import React from 'react';

interface LogoProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

/**
 * Composant Logo réutilisable pour omnia-eg
 * 
 * Placez votre fichier SVG dans: public/logo.svg
 * 
 * @example
 * <Logo className="w-8 h-8 text-primary-600" />
 * <Logo width={32} height={32} className="text-white" />
 */
const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  width = 24, 
  height = 24 
}) => {
  // Si className contient des classes de taille Tailwind (w-* ou h-*), 
  // on ne passe pas les attributs width/height pour éviter les conflits
  const hasSizeClasses = className.includes('w-') || className.includes('h-');
  
  return (
    <img 
      src="/logo.svg" 
      alt="omnia-eg Logo" 
      {...(!hasSizeClasses && { width, height })}
      className={className}
    />
  );
};

export default Logo;

